export default __webpack_public_path__ + "assets/print-component.b9b18f58.svg";